import React, { lazy } from 'react';
const bonuses = [{
  num: '1',
  title: 'Kit Rentrée EPS Express',
  subtitle: 'Préparez vos 4 premières semaines en moins de 30 minutes',
  value: '29€',
  img: 'https://cdn.magicpatterns.com/uploads/pgLR6WWhj28QzJx44paJHP/c319199c-3716-468c-bdea-b43297ffa7b2-mockup.webp'
}, {
  num: '2',
  title: 'Banque de Consignes "Prêtes à Dire"',
  subtitle: 'Copiez et collez des phrases professionnelles pour lancer vos activités en 10 secondes',
  value: '39€',
  img: 'https://cdn.magicpatterns.com/uploads/mgknViia3BzSwHAZQiuGZp/3c44db9b-6d11-463b-8853-25fb7cae4a11-mockup.webp'
}, {
  num: '3',
  title: 'Kit Anti-Chaos Gymnase',
  subtitle: "Protocoles pour gérer les classes nombreuses et maintenir l'ordre sans crier",
  value: '49€',
  img: 'https://cdn.magicpatterns.com/uploads/1HxcLTFpmGaNJsrzqYiece/87b4edd6-e8e7-4f2e-80ea-5e1d4b34b4c8-mockup.webp'
}, {
  num: '4',
  title: 'Pack Évaluation LSU & BAC',
  subtitle: 'Modèles de lettres pour les parents et documents administratifs pour la direction',
  value: '29€',
  img: 'https://cdn.magicpatterns.com/uploads/vGrnGk8DRvruE8MLn3K5kh/b39abc0e-1721-44a0-b299-161b45714d42-mockup.webp'
}, {
  num: '5',
  title: 'Kit Plan B — Spécial Pluie',
  subtitle: 'Séances de secours en salle de classe ou espaces réduits quand le gymnase est indisponible',
  value: '19€',
  img: 'https://cdn.magicpatterns.com/uploads/i8CUGNo9ck3mbmeJS88MmZ/012a0bd5-69d1-41e9-a7f7-26092dd56ec5-mockup.webp'
}];
export function BonusSection() {
  return <section className="w-full bg-bg-dark py-16 sm:py-24 px-4" data-id="element-10">
      <div className="max-w-5xl mx-auto" data-id="element-11">
        <div className="text-center mb-12" data-id="element-12">
          <h2 className="text-3xl sm:text-5xl font-serif font-black text-text-main mb-4" data-id="element-13">
            🎁 5 Bonus Exclusifs
          </h2>
          <p className="text-text-sec text-lg sm:text-xl font-medium" data-id="element-14">
            Valeur <span className="line-through text-secondary" data-id="element-15">165€</span> —
            Inclus <span className="font-bold text-primary" data-id="element-16">GRATUITEMENT</span>
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6" data-id="element-17">
          {bonuses.map((bonus, i) => <div key={i} className="bg-bg-alt rounded-2xl border border-border-light flex flex-col shadow-sm overflow-hidden transition-all hover:shadow-md hover:-translate-y-0.5" data-id="element-18">
              <div className="relative aspect-square bg-bg-main overflow-hidden p-8 sm:p-10" data-id="element-19">
                <img src={bonus.img} alt={bonus.title} loading="lazy" decoding="async" className="w-full h-full object-contain" data-id="element-20" />
                <div className="absolute top-3 left-3 w-9 h-9 rounded-full bg-primary text-white flex items-center justify-center font-serif font-black text-lg shadow-md" data-id="element-21">
                  {bonus.num}
                </div>
              </div>
              <div className="p-6 flex flex-col flex-1" data-id="element-22">
                <p className="text-text-sec text-xs font-bold uppercase tracking-wider mb-1" data-id="element-23">
                  Bonus {bonus.num}
                </p>
                <h3 className="text-text-main font-bold text-lg leading-tight mb-1" data-id="element-24">
                  {bonus.title}
                </h3>
                <p className="text-text-sec text-sm leading-snug mb-3 flex-1" data-id="element-25">
                  {bonus.subtitle}
                </p>
                <div className="flex items-center gap-2 text-base" data-id="element-26">
                  <span className="text-secondary line-through font-medium" data-id="element-27">
                    {bonus.value}
                  </span>
                  <span className="text-primary font-bold" data-id="element-28">GRATUIT</span>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}